<template>
  <div
      :style="{ minHeight: minHeight }"
      class="flex gap-2 p-2 bg-[#283344] border border-zt-light justify-between rounded-zt mb-4 items-center">
    <span class="text-zt-more text-xs">{{content}}
      <slot></slot>
    </span>
    <div v-if="showIcon" class="min-w-[50px]">
      <svg xmlns="http://www.w3.org/2000/svg" width="44" height="45" viewBox="0 0 44 45" fill="none">
        <path opacity="0.05" d="M39.8839 7.65779L31.2332 6.08541C30.8004 3.52674 28.8398 1.37453 26.1494 0.885513C23.459 0.396494 20.8665 1.72113 19.5609 3.96382L10.9102 2.39144C8.6337 1.97766 6.43255 3.5017 6.01877 5.77821L0.752412 34.752C0.338627 37.0285 1.86267 39.2296 4.13918 39.6434L33.1129 44.9097C35.3894 45.3235 37.5906 43.7995 38.0044 41.523L43.2707 12.5492C43.6845 10.2727 42.1605 8.07158 39.8839 7.65779ZM21.8241 36.4441L17.685 35.6917L18.4373 31.5526L22.5764 32.305L21.8241 36.4441ZM23.3288 28.1659L19.1897 27.4135L21.4467 14.9962L25.5858 15.7485L23.3288 28.1659ZM24.6447 9.16372C23.5065 8.95683 22.7445 7.85626 22.9514 6.718C23.1582 5.57975 24.2588 4.81773 25.3971 5.02462C26.5353 5.23151 27.2974 6.33208 27.0905 7.47034C26.8836 8.60859 25.783 9.37062 24.6447 9.16372Z" fill="#93A3BA"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoBox",
  props: {
    content: {
      type: String,
      default: ''
    },
    showIcon: {
      type: Boolean,
      default: false
    },
    minHeight: {
      type: String,
      default: '60px'
    }
  }
}
</script>

<style scoped>

</style>